// Local translations
export const T = {
  en_GB: {
    editPage: "Edit Page",
    createNewPage: "Create New Page",
    editPageDescription: "Update the page information below.",
    createPageDescription: "Enter a name for the new page.",
    pageName: "Page Name",
    pageNamePlaceholder: "e.g., Personal Information, Documents",
    enableAdvisorNotes: "Enable Advisor Notes",
    enableAdvisorNotesDescription:
      "Show a rich text editor at the end of this page for internal notes",
    requireAdvisorNotes: "Require Advisor Notes",
    requireAdvisorNotesDescription:
      "The advisor must write a note on this page before the flow can be submitted",
    conditionalVisibility: "Conditional Visibility",
    conditionalVisibilityDescription: "Show this page only when a condition is met",
    pageNameRequired: "Page name is required",
    failedToSavePage: "Failed to save page",
    cancel: "Cancel",
    save: "Save",
    addPage: "Add Page",
  },
  nb_NO: {
    editPage: "Rediger side",
    createNewPage: "Opprett ny side",
    editPageDescription: "Oppdater sideinformasjonen nedenfor.",
    createPageDescription: "Skriv inn et navn for den nye siden.",
    pageName: "Sidenavn",
    pageNamePlaceholder: "f.eks. Personopplysninger, Dokumenter",
    enableAdvisorNotes: "Aktiver rådgivernotater",
    enableAdvisorNotesDescription:
      "Vis et rikt tekstredigeringsprogram på slutten av denne siden for interne notater",
    requireAdvisorNotes: "Krev rådgivernotater",
    requireAdvisorNotesDescription:
      "Rådgiveren må skrive et notat på denne siden før flyten kan sendes inn",
    conditionalVisibility: "Betinget synlighet",
    conditionalVisibilityDescription: "Vis denne siden kun når en betingelse er oppfylt",
    pageNameRequired: "Sidenavn er obligatorisk",
    failedToSavePage: "Kunne ikke lagre side",
    cancel: "Avbryt",
    save: "Lagre",
    addPage: "Legg til side",
  },
} as const;
